export const LIST_INDUSTRIES = [
  'Animals & Pet Supplies',
  'Apparel & Accessories',
  'Arts & Entertainment',
  'Baby & Toddler',
  'Business & Industrial',
  'Cameras & Optics',
  'Electronics',
  'Food, Beverages & Tobacco',
  'Furniture',
  'Hardware',
  'Health & Beauty',
  'Home & Garden',
  'Luggage & Bags',
  'Mature',
  'Media',
  'Office Supplies',
  'Religious & Ceremonial',
  'Software',
  'Sporting Goods',
  'Toys & Games',
  'Vehicles & Parts'
];

export const NEW_ONBOARDING_SSR_USER = '2024-03-06T00:00:01+00:00'; //'2024-03-06T14:39:48+07:00';

export const DATA_DEFAULT_INDUSTRIES = [
  {
    value: 'Apparel & Accessories',
    label: 'Apparel & Accessories'
  },
  {
    value: 'Home & Garden',
    label: 'Home & Garden'
  },
  {
    value: 'Health & Beauty',
    label: 'Health & Beauty'
  },
  {
    value: 'Sporting Goods',
    label: 'Sporting Goods'
  },
  {
    value: 'Food, Beverages & Tobacco',
    label: 'Food, Beverages & Tobacco'
  },
  {
    value: 'Baby & Toddler',
    label: 'Baby & Toddler'
  }
];

export const DATA_PLUGIN = [
  {
    image: '/assets/images/installation/icon-filter.svg',
    title: 'AdminHTML.InstallationV2.KYC.step1_filter_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_filter_description',
    value: 'PRODUCT_FILTER',
    hover: '/assets/images/installation/feature-filter-2x.png'
  },
  {
    image: '/assets/images/installation/icon-search.svg',
    title: 'AdminHTML.InstallationV2.KYC.step1_search_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_search_description',
    value: 'PRODUCT_SEARCH',
    hover: '/assets/images/installation/feature-search-2x.png'
  },
  {
    image: '/assets/images/installation/icon-visual.svg',
    title: 'AdminHTML.InstallationV2.KYC.step1_visual_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_visual_description',
    value: 'VISUAL_MERCHANDISING',
    hover: '/assets/images/installation/feature-visual-2x.png'
  },
  {
    image: '/assets/images/installation/icon-recommendation.svg',
    title: 'AdminHTML.InstallationV2.KYC.step1_recommendation_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_recommendation_description',
    value: 'PRODUCT_RECOMMENDATION',
    hover: '/assets/images/installation/feature-recommendation-2x.png'
  }
];

export const DATA_REVENUE = [
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_1',
    value: 'lessThan0'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_2',
    value: 'from1To10'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_3',
    value: 'from10To15'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_4',
    value: 'above15'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_5',
    value: 'notSay'
  }
];

export const DATA_ONBOARDING = [
  {
    image: '/assets/images/installation/onboarding1-2x.png',
    title: 'AdminHTML.InstallationV2.Onboarding.step1_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step1_description',
    value: 'onboarding_step1'
  },
  {
    image: '/assets/images/installation/onboarding2-2x.png',
    title: 'AdminHTML.InstallationV2.Onboarding.step2_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step2_description',
    value: 'onboarding_step2'
  },
  {
    image: '/assets/images/installation/onboarding3-2x.png',
    title: 'AdminHTML.InstallationV2.Onboarding.step3_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step3_description',
    value: 'onboarding_step3'
  },
  {
    image: '/assets/images/installation/onboarding4-2x.png',
    title: 'AdminHTML.InstallationV2.Onboarding.step4_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step4_description',
    value: 'onboarding_step4'
  },
  {
    image: '/assets/images/installation/onboarding5-2x.png',
    title: 'AdminHTML.InstallationV2.Onboarding.step5_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step5_description',
    value: 'onboarding_step5'
  },
  {
    image: '/assets/images/installation/onboarding6-2x.png',
    title: 'AdminHTML.InstallationV2.Onboarding.step6_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step6_description',
    value: 'onboarding_step6'
  }
];

export const DEFAULT_SELECT_FEATURE_ON_THEME_SETUP_ONBOARDING = {
  PRODUCT_FILTER: ['filterCollection', 'filterSearch'],
  PRODUCT_SEARCH: ['instantSearch'],
  VISUAL_MERCHANDISING: ['instantSearch'],
  PRODUCT_RECOMMENDATION: ['recommendation']
};

export const getFeatureByFeatureInterestKYC = (features, isOldUser) => {
  if (!features.length && isOldUser) {
    return {
      filterCollection: true,
      filterSearch: true,
      instantSearch: true,
      recommendation: true
    };
  }
  const allFeatures = [];
  features.forEach(feature => {
    const feat = DEFAULT_SELECT_FEATURE_ON_THEME_SETUP_ONBOARDING[feature];
    if (feat) {
      allFeatures.push(...feat);
    }
  });
  const data = [...new Set(allFeatures)];
  const objFeature = {
    filterCollection: data.includes('filterCollection'),
    filterSearch: data.includes('filterSearch'),
    instantSearch: data.includes('instantSearch'),
    recommendation: data.includes('recommendation')
  };

  return objFeature;
};
